<template>
  <v-card elevation="0" tile color="transparent">
    <v-card-text class="pb-0 pl-0 pr-0">
      <div data-cy="listFilter-importKey-input">
        <v-textarea
          clearable
          :hint="`${importKeyAttributeLabel}s can be separated by commas, spaces, or copy-pasted from Excel`"
          :label="`${importKeyAttributeLabel} List`"
          outlined
          persistent-hint
          v-model="filterString"
          @input="updateEntityListFiltered"
        ></v-textarea>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getLabel, hasValue, normalizeValue } from "@/lib/componentUtil";

import listFilterMixin from "./listFilterMixin";

export default {
  computed: {
    importKeyAttributeLabel() {
      const { importKeyAttribute } = this;

      const importKeyAttributeLabel = getLabel(importKeyAttribute);

      return importKeyAttributeLabel;
    },
    importKeyAttributeName() {
      return this.importKeyAttribute.name;
    },
  },
  methods: {
    filter(entityListFormatted, filterString) {
      const { importKeyAttributeName } = this;

      const filterTermList = filterString
        // filterTermSeparator is defined in mixin
        .split(this.filterTermSeparator)
        .filter(hasValue)
        .map(normalizeValue);

      return entityListFormatted.filter(
        ({ [importKeyAttributeName]: importKeyValue }) =>
          // Array.find() will exit on first filterTerm match
          !!filterTermList.find(
            filterTerm => filterTerm === normalizeValue(importKeyValue)
          )
      );
    },
  },
  mixins: [listFilterMixin],
  props: {
    importKeyAttribute: {
      required: true,
      type: Object,
    },
  },
};
</script>
